import { Injectable, Inject, forwardRef } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { Response } from '@angular/http';

import { Effect, Actions, toPayload } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { AppState } from '../../reducers';

import { MerchantApi, AccountApi, MerchantEmailConfigApi } from "../../services";
import { MerchantActions } from './merchant.actions'
import { MessageActions } from '../../actions';
import { ErrorHandlerService } from '../../services/index';
import { Merchant } from "../../models"
import { UnsafeAction } from "../../actions/UnsafeAction";


/* tslint:disable */
@Injectable()
export class MerchantEffects {
	constructor(
		private updates$: Actions,
		private state$: Store<AppState>,
		private merchantApi: MerchantApi,
		private merchantActions: MerchantActions,
		private messageActions: MessageActions,
		private errorHandler: ErrorHandlerService,
		private accountApi: AccountApi,
		private merchantEmailConfigApi: MerchantEmailConfigApi
	) { }

	@Effect() loadMerchantList$ = this.updates$
		.ofType(MerchantActions.LOAD_MERCHANT_LIST)
		.flatMap(action => this.merchantApi.getMerchants()
			.map(merchantList => this.merchantActions.loadMerchantListSuccess(merchantList)))
		.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten.fgdgdgdg"))


	@Effect() removeMerchantLogo = this.updates$
		.ofType(MerchantActions.REMOVE_MERCHANT_LOGO)
		.withLatestFrom(this.state$)
		.flatMap( ([action,state]) => this.merchantApi.removeMerchantLogo(state.merchantState.merchant))
		.do(data => this.state$.dispatch(this.messageActions.displayMessage("Das Merchant-Logo wurde gelöscht!", "success")))
		.map(merchant => this.merchantActions.deleteMerchantLogoSuccess())
		.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))

	@Effect() saveBillingInfo$ = this.updates$
		.ofType(MerchantActions.SAVE_MERCHANT_CONFIG)
		.withLatestFrom(this.state$)
		.flatMap(([action, state]:[UnsafeAction, AppState]) =>
			this.merchantApi.saveMerchantConfig(state.merchantState.merchant._links.self.href, action.payload)
				.flatMap(merchant => {
					if (state.merchantState.merchantConfigPreviewFileObject) {
						return this.merchantApi.saveMerchantLogo(state.merchantState.merchantConfigPreviewFileObject, state.merchantState.merchant.merchantId)
							.filter(event => event.currentTarget["status"] === 200)
							.map(event => <Merchant>JSON.parse(event.currentTarget["responseText"]))
					} else {
						return Observable.of(merchant);
					}
				})
		)
		.do(data => this.state$.dispatch(this.messageActions.displayMessage("Die Merchant Konfiguration wurde erfolgreich gespeichert!", "success")))
		.map(merchant => this.merchantActions.saveMerchantConfigSuccess(merchant))
		.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))


	@Effect() loadMerchantByMerchantId$ = this.updates$
		.ofType(MerchantActions.LOAD_MERCHANT_BY_MERCHANT_ID)
		.flatMap((action: UnsafeAction) => this.merchantApi.loadMerchantByMerchantId(action.payload)
			.map(merchant => this.merchantActions.loadMerchantByMerchantIdSuccess(merchant))
			.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))
		)

	@Effect() loadMerchantAccounts$ = this.updates$
		.ofType(MerchantActions.LOAD_MERCHANT_ACCOUNTS)
		.flatMap((action: UnsafeAction) => this.accountApi.getAccountsForMerchant(action.payload)
			.map(merchantAccounts => this.merchantActions.loadMerchantAccountsSuccess(merchantAccounts)))
			.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))

	@Effect() loadMerchantAccountById$ = this.updates$
		.ofType(MerchantActions.LOAD_MERCHANT_ACCOUNT_BY_ID)
		.flatMap((action: UnsafeAction) => this.accountApi.getMerchantAccountById(action.payload)
			.map(merchantAccount => this.merchantActions.merchantAccountLoaded(merchantAccount)))
			.catch(error => this.handleError(error, "Es ist eine unerwarteter Fehler aufgetreten."))

	@Effect() loadBookingOfficesByUrl = this.updates$
		.ofType(MerchantActions.LOAD_BOOKING_OFFICES)
		.flatMap((action: UnsafeAction) => this.merchantApi.loadBookingOffices(action.payload)
			.map(bookingOffices => this.merchantActions.loadBookingOfficesSuccess(bookingOffices)))
			.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))

	@Effect() loadMerchantEmailConfigs$ = this.updates$
		.ofType(MerchantActions.LOAD_MERCHANT_EMAIL_CONFIGS)
		.flatMap((action: UnsafeAction) => this.merchantEmailConfigApi.getMerchantEmailConfigs(action.payload)
			.map(merchantEmailConfigs => this.merchantActions.loadMerchantEmailConfigsSuccess(merchantEmailConfigs)))
			.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))


	private handleError(error: Response, defaultMessage: string): Observable<Action> {
		let errorMessage = this.errorHandler.getErrorMessage(error, defaultMessage)
		return Observable.of(this.messageActions.displayMessage(errorMessage, "error"))
	}
}



// WEBPACK FOOTER //
// ./src/app/components/merchants/merchant.effects.ts